import compareVersions, {
    VERSION_CM_6345_CATEGORY_BULK_VIDEO
} from '../cores/version';

// ##################################
// WARNING !!!!!
// TODO: 이거 쓰지 마세요.
// 2021-11-16 기준 배포된 고객 Space 버젼 보고 카테고리 뷰 기능 지원 기준을 1.0.23으로 분기친 것임.
// ##################################

const getAccessHierachyView = (stageVersion) => {
    if(!stageVersion) return false;

    return compareVersions(stageVersion, VERSION_CM_6345_CATEGORY_BULK_VIDEO) >= 0;
};

export default getAccessHierachyView;
